import { defineComponent as n, computed as o, openBlock as i, createElementBlock as d, createElementVNode as e, toDisplayString as r, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "0f78a8cd-9ed5-479e-94be-d9ebd78555a1" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#0f78a8cd-9ed5-479e-94be-d9ebd78555a1)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m0 167 256-32 256 32v178l-256 32L0 345Z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "M0 345h512v167H0Z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 0h512v167H0Z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m373 373 36 112-94-69h117l-95 69z"
}, null, -1), w = { fill: "none" }, y = ["r"], N = /* @__PURE__ */ n({
  __name: "kanuri",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const t = a, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), c = o(() => 256 + t.strokeWidth / 2);
    return (W, b) => (i(), d("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (i(), d("title", k, r(t.flagName), 1)) : f("", !0),
        p,
        v,
        g,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, y)
      ])
    ], 8, h));
  }
});
export {
  N as default
};
//# sourceMappingURL=kanuri-871b7294.js.map
